import MDDatePicker from "../MDDatePicker";
import moment from "moment";

const DateFilter = ({ label = "Fecha", filterList, onChange, index, column }) => {
    const value = filterList[index] || '';
    return (
        <div>
            <MDDatePicker
                variant="standard"
                input={{ label: label, fullWidth: true }}
                options={{ mode: 'range', dateFormat: "Y-m-d" }}
                value={value}
                onChange={(date) => onChange(
                    [date[0].toISOString().slice(0, 10), date[1].toISOString().slice(0, 10)],
                    index,
                    column
                )}
            />
        </div>
    );
};

export default DateFilter;
